import React, { useEffect, useState } from "react";

import {
  Edit,
  SaveButton,
  SimpleForm,
  Toolbar,
  TopToolbar,
  useEditController,
  useNotify,
  useRecordContext,
} from "react-admin";

import { BackButton } from "../../../components/common/BackButton";
import { ForceTitle } from "../../../components/common/ForceTitle";
import { logError } from "../../../utils/appUtils";
import { deepRedirect, getBackPath } from "../../../utils/utils";
import { AssetTypeForm } from "./AssetTypeForm";
import { DeepDeleteAssetTypeButton } from "./DeepDeleteAssetTypeButton";
import { fetchEventTypes } from "./AssetTypeUtils";

const EditToolbar = (props) => {
  const notify = useNotify();
  const { eventTypes, backPath, history } = props;
  const [saving, setSaving] = useState(false);
  const record = useRecordContext();

  const onSuccess = () => {
    setSaving(false);
    notify(`Asset updated successfully.`);
    deepRedirect(history, backPath);
  };

  const onFailure = (error) => {
    setSaving(false);
    logError("assetTypes:AssetTypeEdit:onFailure", error, notify);
  };

  return (
    <Toolbar {...props} style={{ justifyContent: "space-between" }}>
      <SaveButton
        label="Save"
        disabled={props.pristine || saving}
        onSuccess={onSuccess}
        onFailure={onFailure}
      />
      <DeepDeleteAssetTypeButton
        record={record}
        eventTypes={eventTypes}
        history={history}
        backPath={backPath}
        notify={notify}
      />
    </Toolbar>
  );
};

const EditActions = (props) => (
  <TopToolbar>
    <BackButton {...props} />
  </TopToolbar>
);

export const AssetTypeEdit = (props) => {
  const notify = useNotify();
  const { record } = useEditController(props);
  const [eventTypes, setEventTypes] = useState([]);
  const backPath = getBackPath(props);

  useEffect(() => {
    if (record) {
      fetchEventTypes(record, setEventTypes, notify);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [record]);

  return (
    <Edit
      {...props}
      title={<ForceTitle title="Edit Asset" />}
      mutationMode="pessimistic"
      actions={<EditActions {...props} backPath={backPath} />}
    >
      <SimpleForm
        variant="outlined"
        submitOnEnter={false}
        toolbar={
          <EditToolbar {...props} eventTypes={eventTypes} backPath={backPath} />
        }
      >
        <AssetTypeForm eventTypes={eventTypes} />
      </SimpleForm>
    </Edit>
  );
};
